export default {
  provinsi: [],
  kota: [],
  kecamatan: [],
  search: []
}